module.exports = __webpack_public_path__ + "img/group_people.dfd3ab66.png";